import Hero from '../components/Hero';
import TechStack from '../components/TechStack';
import Services from '../components/Services';
import Portfolio from '../components/Portfolio';
import Contact from '../components/Contact';
import About from '../components/About';

const Home = () => {
    return (
        <>
            <Hero />
            <About></About>
            <TechStack />
            <Services />
            <Portfolio />
            <Contact></Contact>
        </>
    );
};

export default Home;